
import Utils from "../../../../util";
import { EconomicMetrics } from "./economic-metrics.model";
import { PartnershipEAFM, makePartnership } from "./partnership.model";
import { LeverageRatios } from "./leverage-ratios.model";
import { CoverageRatios } from "./coverage-ratios.model";
import { ReturnRatios } from "./return-ratios.model";
import { MarginRatios } from "./margin-ratios.model";
import { cloneDeep } from "lodash-es";

interface EAFMInterface {
 'RESULTS.DATA.ECONOMIC_METRICS.TITLE'?: EconomicMetrics;
 'RESULTS.DATA.ECONOMIC_METRICS.LR'?: LeverageRatios;
 'RESULTS.DATA.ECONOMIC_METRICS.CR'?: CoverageRatios;
 'RESULTS.DATA.ECONOMIC_METRICS.RR'?: ReturnRatios;
 'RESULTS.DATA.ECONOMIC_METRICS.MR'?: MarginRatios;
 'RESULTS.DATA.PARTNERSHIP'?: Record<string, PartnershipEAFM>;
}
/**
 * economic and financial metrics
 */
export class EAFM {
  'RESULTS.DATA.ECONOMIC_METRICS.TITLE';
  'RESULTS.DATA.ECONOMIC_METRICS.LR';
  'RESULTS.DATA.ECONOMIC_METRICS.CR';
  'RESULTS.DATA.ECONOMIC_METRICS.RR';
  'RESULTS.DATA.ECONOMIC_METRICS.MR';
  'RESULTS.DATA.PARTNERSHIP';

  get economicMetrics() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.TITLE'];
  }
  set economicMetrics(value: EconomicMetrics) {
    this['RESULTS.DATA.ECONOMIC_METRICS.TITLE'] = value;
  }
  get leverageRatios() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.LR'];
  }
  set leverageRatios(value: LeverageRatios) {
    this['RESULTS.DATA.ECONOMIC_METRICS.LR'] = value;
  }
  get coverageRatios() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.CR'];
  }
  set coverageRatios(value: CoverageRatios) {
    this['RESULTS.DATA.ECONOMIC_METRICS.CR'] = value;
  }
  get returnRatios() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.RR'];
  }
  set returnRatios(value: ReturnRatios) {
    this['RESULTS.DATA.ECONOMIC_METRICS.RR'] = value;
  }
  get marginRatios() {
    return this['RESULTS.DATA.ECONOMIC_METRICS.MR'];
  }
  set marginRatios(value: MarginRatios) {
    this['RESULTS.DATA.ECONOMIC_METRICS.MR'] = value;
  }
  get partnership() {
    return this['RESULTS.DATA.PARTNERSHIP'];
  }
  set partnership(value: Record<string, PartnershipEAFM>) {
    this['RESULTS.DATA.PARTNERSHIP'] = value;
  }

  constructor(param: EAFMInterface = {}) {
    this['RESULTS.DATA.ECONOMIC_METRICS.TITLE'] = param['RESULTS.DATA.ECONOMIC_METRICS.TITLE']
      ? new EconomicMetrics(param['RESULTS.DATA.ECONOMIC_METRICS.TITLE'])
      : new EconomicMetrics();

    this['RESULTS.DATA.ECONOMIC_METRICS.LR'] = param['RESULTS.DATA.ECONOMIC_METRICS.LR']
      ? new LeverageRatios(param['RESULTS.DATA.ECONOMIC_METRICS.LR'])
      : new LeverageRatios();

    this['RESULTS.DATA.ECONOMIC_METRICS.CR'] = param['RESULTS.DATA.ECONOMIC_METRICS.CR']
      ? new CoverageRatios(param['RESULTS.DATA.ECONOMIC_METRICS.CR'])
      : new CoverageRatios();

    this['RESULTS.DATA.ECONOMIC_METRICS.RR'] = param['RESULTS.DATA.ECONOMIC_METRICS.RR']
      ? new ReturnRatios(param['RESULTS.DATA.ECONOMIC_METRICS.RR'])
      : new ReturnRatios();

    this['RESULTS.DATA.ECONOMIC_METRICS.MR'] = param['RESULTS.DATA.ECONOMIC_METRICS.MR']
      ? new MarginRatios(param['RESULTS.DATA.ECONOMIC_METRICS.MR'])
      : new MarginRatios();

    this['RESULTS.DATA.PARTNERSHIP'] = Utils.ObjectMapper(param['RESULTS.DATA.PARTNERSHIP'] || {}, makePartnership);
  }

  deepCopy() {
    return new EAFM(cloneDeep(this));
  }
}
